"use client";

import { generalAnalitica } from "@/app/(store)/_utils/events";
import { GlobalFeedback } from "@/components/global-feedback";
import { useEffectOnce } from "@/hooks/use-effect-once";

const ErrorPage = () => {
  useEffectOnce(() => {
    generalAnalitica.events.view.error();
  });

  return (
    <GlobalFeedback
      data={{
        icon: "circle-error",
        title: "Não foi possível continuar",
        message:
          "Algo inesperado aconteceu. Você pode tentar de novo em alguns instantes.",
      }}
    />
  );
};

export default ErrorPage;
